module.exports = __webpack_public_path__ + "static/colours-mockup-afcc020d77aa8c7f22f7d765a00d3206.png";